@for (fragment of fragments; track $index) {
    @if (fragment.type === NOTIFICATION_FRAGMENT_TYPE.Text) {
        {{ fragment.value | translateTokenisedString }}
    }
    @if (fragment.type === NOTIFICATION_FRAGMENT_TYPE.Link) {
        <a
            [routerLink]="fragment.routerLink"
            [queryParams]="fragment.queryParams"
            [attr.data-cy]="'notification-link-' + fragment.value"
            (click)="fragment.routerLink && onLinkSelected()"
        >
            {{ fragment.value | translateTokenisedString }}
        </a>
    }
    @if (fragment.type === NOTIFICATION_FRAGMENT_TYPE.FileDownload) {
        <button wdxButton="inline" (click)="onDownload(fragment)">
            {{ fragment.value }}
        </button>
    }
}
